import { I18nUtil } from "@utils/i18n";
import { Icon } from "@ospweb/sdk-ui";
import Translations from "@translate/components/Chat/JsonRenderComponents/ViewMore";
import { buildOpenReplayLabel } from "@utils/openreplay";

const I18n = I18nUtil.createScoped(Translations);

export interface ViewMoreProps {
  onClick?: () => void;
  /** v2 Scene for OpenReplay DOM label (e.g. Chat vs Notification). */
  openReplayScene?: string;
}

export const ViewMore = ({ onClick, openReplayScene }: ViewMoreProps) => {
  return (
    <button
      aria-label="View More"
      data-openreplay-label={buildOpenReplayLabel(
        openReplayScene ?? "Notification",
        "NotificationCard",
        "Open",
      )}
      id="btn-view-more"
      type="button"
      className="flex flex-row items-center gap-1 button_s text-content_primary py-1.5 w-fit"
      onClick={onClick}
    >
      <span className="button_s">{I18n.t("View More")}</span>
      <Icon name="chevron-down" size={16} />
    </button>
  );
};
